import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import Div100vh from 'react-div-100vh';

import { overlay } from '../../constants/styles';

// Local Typings
export interface OverlayProps {
  transition: number;
  withTint?: boolean;
}

// Component Definition
const Overlay = styled(Div100vh,
  {
    shouldForwardProp: isPropValid,
  })<OverlayProps>(({
  transition = 300,
  withTint = false,
}) => ({
  backgroundColor: withTint ? overlay : undefined,
  left: 0,
  overflowY: 'auto',
  pointerEvents: withTint ? undefined : 'none',
  position: 'fixed',
  top: 0,
  transition: `${transition}ms}`,
}));

export default Overlay;
